import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})



router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'))

  if (to.meta.requiresAuth && !user) {
    return next('/login')
  }

  // Acceso por vista (configurable por rol). Dashboard queda siempre accesible
  // porque es el destino del redirect.
  if (to.meta.viewKey) {
    const userViews = user?.views || []

    if (!userViews.includes(to.meta.viewKey)) {
      return next('/dashboard')
    }
  }

  // Compatibilidad: rutas antiguas que aún usen meta.roles
  if (to.meta.roles) {
    const userRoles = user?.roles || []
    if (!to.meta.roles.some(role => userRoles.includes(role))) {
      return next('/dashboard')
    }
  }

  next()
})



export default function (app) {
  app.use(router)
}
export { router }


